<template>
  <component :is="container" :to="link" :target="target">
    <div class="class-card">
      <NewTag
        v-if="isNew"
        class="absolute left-[10px] top-[10px] z-10"
      ></NewTag>
      <HoverVideo
        :data="{
          cover_url: src,
          hover_video: video,
        }"
      />
    </div>
  </component>
</template>

<script setup lang="ts">
import HoverVideo from './hoverVideo/index.vue'
import { NuxtLink } from '#components'

const props = defineProps<{
  url: string
  link: object
  target?: string
  video: string
  isNew?: boolean
}>()

const container = props.link ? NuxtLink : 'div'

const DEFAULT_IMG = getFeUrl('/youyan-platform/png/home/img-placeholder-2x.png')

const src = computed(() => {
  return props.url || DEFAULT_IMG
})
</script>

<style lang="scss" scoped>
.class-card {
  @apply rounded-[12px] overflow-hidden h-full w-full bg-back-5 relative;
  .images {
    transition: all 0.5s ease-out;
  }
  &:hover {
    .images {
      transform: scale(1.1);
    }
  }
}
</style>
